<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>招商管理</el-breadcrumb-item>
      <el-breadcrumb-item>回收站</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="box-card">
      <div slot="header" class="flexContainer">
        <span class="cardHeader">回收站</span>
      </div>

      <el-tabs v-model="activeTab" type="border-card" @tab-click="handleTabClick">
        <!-- 已删除客户 -->
        <el-tab-pane label="已删除客户" name="customer">
          <div class="search-bar">
            <el-form :inline="true" size="small">
              <el-form-item label="关键词">
                <el-input v-model="customerQuery.keyword" placeholder="客户名称/联系人/手机号" clearable @clear="getCustomerTrashList(true)" @keyup.enter.native="getCustomerTrashList(true)"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="getCustomerTrashList(true)">查询</el-button>
                <el-button icon="el-icon-refresh" @click="resetCustomerQuery">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
          <el-table :data="customerList" border height="calc(100vh - 380px)">
            <el-table-column label="序号" type="index" width="60px"></el-table-column>
            <el-table-column label="客户名称" prop="title" min-width="120px"></el-table-column>
            <el-table-column label="联系人" prop="name" width="100px"></el-table-column>
            <el-table-column label="联系方式" prop="mobile" width="130px"></el-table-column>
            <el-table-column label="来源" prop="from" width="100px"></el-table-column>
            <el-table-column label="创建人" prop="creatorName" width="100px"></el-table-column>
            <el-table-column label="创建时间" width="170px">
              <template slot-scope="scope">{{ scope.row.createDate | dateFormat }}</template>
            </el-table-column>
            <el-table-column label="删除时间" width="170px">
              <template slot-scope="scope">{{ scope.row.updateDate | dateFormat }}</template>
            </el-table-column>
            <el-table-column label="删除信息" min-width="160px">
              <template slot-scope="scope">
                <div v-if="scope.row.deleteInfo">
                  <div>{{ scope.row.deleteInfo.operatorName }}</div>
                  <div style="font-size:12px;color:#999;" :title="scope.row.deleteInfo.remark">{{ scope.row.deleteInfo.remark || '（未填写原因）' }}</div>
                </div>
                <span v-else style="color:#bbb">—</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180px" fixed="right">
              <template slot-scope="scope">
                <el-button type="warning" plain size="mini" @click="restoreCustomer(scope.row)">还原</el-button>
                <el-button type="danger" plain size="mini" @click="permanentDeleteCustomer(scope.row)">彻底删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="customerSizeChange"
            @current-change="customerPageChange"
            :current-page="customerQuery.pagenum"
            :page-sizes="[10, 20, 50]"
            :page-size="customerQuery.pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="customerTotal">
          </el-pagination>
        </el-tab-pane>

        <!-- 已删除项目 -->
        <el-tab-pane label="已删除项目" name="project">
          <div class="search-bar">
            <el-form :inline="true" size="small">
              <el-form-item label="关键词">
                <el-input v-model="projectQuery.keyword" placeholder="项目名称/客户名称" clearable @clear="getProjectTrashList(true)" @keyup.enter.native="getProjectTrashList(true)"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="getProjectTrashList(true)">查询</el-button>
                <el-button icon="el-icon-refresh" @click="resetProjectQuery">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
          <el-table :data="projectList" border height="calc(100vh - 380px)">
            <el-table-column label="序号" type="index" width="60px"></el-table-column>
            <el-table-column label="项目名称" prop="projectName" min-width="140px"></el-table-column>
            <el-table-column label="客户名称" prop="customerName" min-width="120px"></el-table-column>
            <el-table-column label="签约人" prop="signerName" width="100px"></el-table-column>
            <el-table-column label="签约类型" prop="signType" width="120px"></el-table-column>
            <el-table-column label="创建时间" width="170px">
              <template slot-scope="scope">{{ scope.row.createDate | dateFormat }}</template>
            </el-table-column>
            <el-table-column label="删除时间" width="170px">
              <template slot-scope="scope">{{ scope.row.updateDate | dateFormat }}</template>
            </el-table-column>
            <el-table-column label="删除信息" min-width="160px">
              <template slot-scope="scope">
                <div v-if="scope.row.deleteInfo">
                  <div>{{ scope.row.deleteInfo.operatorName }}</div>
                  <div style="font-size:12px;color:#999;" :title="scope.row.deleteInfo.remark">{{ scope.row.deleteInfo.remark || '（未填写原因）' }}</div>
                </div>
                <span v-else style="color:#bbb">—</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180px" fixed="right">
              <template slot-scope="scope">
                <el-button type="warning" plain size="mini" @click="restoreProject(scope.row)">还原</el-button>
                <el-button type="danger" plain size="mini" @click="permanentDeleteProject(scope.row)">彻底删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="projectSizeChange"
            @current-change="projectPageChange"
            :current-page="projectQuery.pagenum"
            :page-sizes="[10, 20, 50]"
            :page-size="projectQuery.pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="projectTotal">
          </el-pagination>
        </el-tab-pane>

        <!-- 已删除合同 -->
        <el-tab-pane label="已删除合同" name="contract">
          <div class="search-bar">
            <el-form :inline="true" size="small">
              <el-form-item label="关键词">
                <el-input v-model="contractQuery.keyword" placeholder="合同编号/客户名称/项目名称" clearable @clear="getContractTrashList(true)" @keyup.enter.native="getContractTrashList(true)"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="getContractTrashList(true)">查询</el-button>
                <el-button icon="el-icon-refresh" @click="resetContractQuery">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
          <el-table :data="contractList" border height="calc(100vh - 380px)">
            <el-table-column label="序号" type="index" width="60px"></el-table-column>
            <el-table-column label="合同编号" prop="contractNo" width="150px"></el-table-column>
            <el-table-column label="项目名称" prop="projectName" min-width="140px"></el-table-column>
            <el-table-column label="客户名称" prop="customerName" min-width="120px"></el-table-column>
            <el-table-column label="合同金额" prop="contractAmount" width="120px"></el-table-column>
            <el-table-column label="创建时间" width="170px">
              <template slot-scope="scope">{{ scope.row.createDate | dateFormat }}</template>
            </el-table-column>
            <el-table-column label="删除时间" width="170px">
              <template slot-scope="scope">{{ scope.row.updateDate | dateFormat }}</template>
            </el-table-column>
            <el-table-column label="删除信息" min-width="160px">
              <template slot-scope="scope">
                <div v-if="scope.row.deleteInfo">
                  <div>{{ scope.row.deleteInfo.operatorName }}</div>
                  <div style="font-size:12px;color:#999;" :title="scope.row.deleteInfo.remark">{{ scope.row.deleteInfo.remark || '（未填写原因）' }}</div>
                </div>
                <span v-else style="color:#bbb">—</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180px" fixed="right">
              <template slot-scope="scope">
                <el-button type="warning" plain size="mini" @click="restoreContract(scope.row)">还原</el-button>
                <el-button type="danger" plain size="mini" @click="permanentDeleteContract(scope.row)">彻底删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="contractSizeChange"
            @current-change="contractPageChange"
            :current-page="contractQuery.pagenum"
            :page-sizes="[10, 20, 50]"
            :page-size="contractQuery.pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="contractTotal">
          </el-pagination>
        </el-tab-pane>

        <!-- 已删除财务 -->
        <el-tab-pane label="已删除财务" name="financial">
          <div class="search-bar">
            <el-form :inline="true" size="small">
              <el-form-item label="关键词">
                <el-input v-model="financialQuery.keyword" placeholder="客户名称/项目名称" clearable @clear="getFinancialTrashList(true)" @keyup.enter.native="getFinancialTrashList(true)"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="getFinancialTrashList(true)">查询</el-button>
                <el-button icon="el-icon-refresh" @click="resetFinancialQuery">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
          <el-table :data="financialList" border height="calc(100vh - 380px)">
            <el-table-column label="序号" type="index" width="60px"></el-table-column>
            <el-table-column label="项目名称" prop="projectName" min-width="140px"></el-table-column>
            <el-table-column label="客户名称" prop="customerName" min-width="120px"></el-table-column>
            <el-table-column label="收支金额" prop="totalAmount" width="120px"></el-table-column>
            <el-table-column label="钱款类型" prop="payType" width="120px"></el-table-column>
            <el-table-column label="创建时间" width="170px">
              <template slot-scope="scope">{{ scope.row.createDate | dateFormat }}</template>
            </el-table-column>
            <el-table-column label="删除时间" width="170px">
              <template slot-scope="scope">{{ scope.row.updateDate | dateFormat }}</template>
            </el-table-column>
            <el-table-column label="删除信息" min-width="160px">
              <template slot-scope="scope">
                <div v-if="scope.row.deleteInfo">
                  <div>{{ scope.row.deleteInfo.operatorName }}</div>
                  <div style="font-size:12px;color:#999;" :title="scope.row.deleteInfo.remark">{{ scope.row.deleteInfo.remark || '（未填写原因）' }}</div>
                </div>
                <span v-else style="color:#bbb">—</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180px" fixed="right">
              <template slot-scope="scope">
                <el-button type="warning" plain size="mini" @click="restoreFinancial(scope.row)">还原</el-button>
                <el-button type="danger" plain size="mini" @click="permanentDeleteFinancial(scope.row)">彻底删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="financialSizeChange"
            @current-change="financialPageChange"
            :current-page="financialQuery.pagenum"
            :page-sizes="[10, 20, 50]"
            :page-size="financialQuery.pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="financialTotal">
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeTab: 'customer',
      // 客户
      customerList: [],
      customerQuery: { keyword: '', pagenum: 1, pagesize: 20 },
      customerTotal: 0,
      // 项目
      projectList: [],
      projectQuery: { keyword: '', pagenum: 1, pagesize: 20 },
      projectTotal: 0,
      // 合同
      contractList: [],
      contractQuery: { keyword: '', pagenum: 1, pagesize: 20 },
      contractTotal: 0,
      // 财务
      financialList: [],
      financialQuery: { keyword: '', pagenum: 1, pagesize: 20 },
      financialTotal: 0
    }
  },
  created () {
    this.getCustomerTrashList()
  },
  methods: {
    handleTabClick (tab) {
      if (tab.name === 'customer') this.getCustomerTrashList()
      else if (tab.name === 'project') this.getProjectTrashList()
      else if (tab.name === 'contract') this.getContractTrashList()
      else if (tab.name === 'financial') this.getFinancialTrashList()
    },

    // ======== 客户 ========
    async getCustomerTrashList (resetPage) {
      if (resetPage) this.customerQuery.pagenum = 1
      const { data: res } = await this.$http.get('zhaoshang/customer/trashList', { params: this.customerQuery })
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.customerList = res.data.list
      this.customerTotal = res.data.total
    },
    resetCustomerQuery () {
      this.customerQuery = { keyword: '', pagenum: 1, pagesize: 20 }
      this.getCustomerTrashList()
    },
    customerSizeChange (newSize) {
      this.customerQuery.pagesize = newSize
      this.getCustomerTrashList()
    },
    customerPageChange (newPage) {
      this.customerQuery.pagenum = newPage
      this.getCustomerTrashList()
    },
    async restoreCustomer (row) {
      const confirm = await this.$confirm('确定要还原该客户吗？', '还原确认', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
      }).catch(() => 'cancel')
      if (confirm === 'cancel') return
      const { data: res } = await this.$http.put(`zhaoshang/customer/restore/${row._id}`)
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.$message.success('还原成功')
      this.getCustomerTrashList()
    },
    async permanentDeleteCustomer (row) {
      const confirm = await this.$confirm('此操作将永久删除该客户，不可恢复！确定要彻底删除吗？', '彻底删除确认', {
        confirmButtonText: '确定删除', cancelButtonText: '取消', type: 'error'
      }).catch(() => 'cancel')
      if (confirm === 'cancel') return
      const reason = await this.promptDeleteReason('客户')
      if (reason === false) return
      const { data: res } = await this.$http.delete(`zhaoshang/customer/removePhysical/${row._id}`, { params: { reason } })
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.$message.success('彻底删除成功')
      this.getCustomerTrashList()
    },

    // 删除原因（必填，操作日志强制留痕）：返回原因字符串；取消返回 false
    async promptDeleteReason (label) {
      const result = await this.$prompt(
        `请输入彻底删除该${label}的原因（必填，将记入操作日志）`,
        '删除原因',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: '例如：测试数据清理',
          inputValidator: v => !!(v && v.trim()) || '删除原因不能为空'
        }
      ).catch((err) => err)

      if (!result || result.action !== 'confirm') {
        this.$message.info('操作已经取消')
        return false
      }
      return result.value.trim()
    },

    // ======== 项目 ========
    async getProjectTrashList (resetPage) {
      if (resetPage) this.projectQuery.pagenum = 1
      const { data: res } = await this.$http.get('zhaoshang/project/trashList', { params: this.projectQuery })
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.projectList = res.data.list
      this.projectTotal = res.data.total
    },
    resetProjectQuery () {
      this.projectQuery = { keyword: '', pagenum: 1, pagesize: 20 }
      this.getProjectTrashList()
    },
    projectSizeChange (newSize) {
      this.projectQuery.pagesize = newSize
      this.getProjectTrashList()
    },
    projectPageChange (newPage) {
      this.projectQuery.pagenum = newPage
      this.getProjectTrashList()
    },
    async restoreProject (row) {
      const confirm = await this.$confirm('确定要还原该项目吗？还原后将同时还原关联的合同和财务记录。', '还原确认', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
      }).catch(() => 'cancel')
      if (confirm === 'cancel') return
      const { data: res } = await this.$http.put(`zhaoshang/project/restore/${row._id}`)
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.$message.success('还原成功')
      this.getProjectTrashList()
    },
    async permanentDeleteProject (row) {
      const confirm = await this.$confirm('此操作将永久删除该项目及其关联数据，不可恢复！确定要彻底删除吗？', '彻底删除确认', {
        confirmButtonText: '确定删除', cancelButtonText: '取消', type: 'error'
      }).catch(() => 'cancel')
      if (confirm === 'cancel') return
      const reason = await this.promptDeleteReason('项目')
      if (reason === false) return
      const { data: res } = await this.$http.delete(`zhaoshang/project/removePhysical/${row._id}`, { params: { reason } })
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.$message.success('彻底删除成功')
      this.getProjectTrashList()
    },

    // ======== 合同 ========
    async getContractTrashList (resetPage) {
      if (resetPage) this.contractQuery.pagenum = 1
      const { data: res } = await this.$http.get('zhaoshang/contract/trashList', { params: this.contractQuery })
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.contractList = res.data.list
      this.contractTotal = res.data.total
    },
    resetContractQuery () {
      this.contractQuery = { keyword: '', pagenum: 1, pagesize: 20 }
      this.getContractTrashList()
    },
    contractSizeChange (newSize) {
      this.contractQuery.pagesize = newSize
      this.getContractTrashList()
    },
    contractPageChange (newPage) {
      this.contractQuery.pagenum = newPage
      this.getContractTrashList()
    },
    async restoreContract (row) {
      const confirm = await this.$confirm('确定要还原该合同吗？还原后将同时还原关联的财务记录。', '还原确认', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
      }).catch(() => 'cancel')
      if (confirm === 'cancel') return
      const { data: res } = await this.$http.put(`zhaoshang/contract/restore/${row._id}`)
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.$message.success('还原成功')
      this.getContractTrashList()
    },
    async permanentDeleteContract (row) {
      const confirm = await this.$confirm('此操作将永久删除该合同及其关联数据，不可恢复！确定要彻底删除吗？', '彻底删除确认', {
        confirmButtonText: '确定删除', cancelButtonText: '取消', type: 'error'
      }).catch(() => 'cancel')
      if (confirm === 'cancel') return
      const reason = await this.promptDeleteReason('合同')
      if (reason === false) return
      const { data: res } = await this.$http.delete(`zhaoshang/contract/removePhysical/${row._id}`, { params: { reason } })
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.$message.success('彻底删除成功')
      this.getContractTrashList()
    },

    // ======== 财务 ========
    async getFinancialTrashList (resetPage) {
      if (resetPage) this.financialQuery.pagenum = 1
      const { data: res } = await this.$http.get('zhaoshang/customerBill/trashList', { params: this.financialQuery })
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.financialList = res.data.list
      this.financialTotal = res.data.total
    },
    resetFinancialQuery () {
      this.financialQuery = { keyword: '', pagenum: 1, pagesize: 20 }
      this.getFinancialTrashList()
    },
    financialSizeChange (newSize) {
      this.financialQuery.pagesize = newSize
      this.getFinancialTrashList()
    },
    financialPageChange (newPage) {
      this.financialQuery.pagenum = newPage
      this.getFinancialTrashList()
    },
    async restoreFinancial (row) {
      const confirm = await this.$confirm('确定要还原该财务记录吗？', '还原确认', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
      }).catch(() => 'cancel')
      if (confirm === 'cancel') return
      const { data: res } = await this.$http.put(`zhaoshang/customerBill/restore/${row._id}`)
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.$message.success('还原成功')
      this.getFinancialTrashList()
    },
    async permanentDeleteFinancial (row) {
      const confirm = await this.$confirm('此操作将永久删除该财务记录，不可恢复！确定要彻底删除吗？', '彻底删除确认', {
        confirmButtonText: '确定删除', cancelButtonText: '取消', type: 'error'
      }).catch(() => 'cancel')
      if (confirm === 'cancel') return
      const reason = await this.promptDeleteReason('财务记录')
      if (reason === false) return
      const { data: res } = await this.$http.delete(`zhaoshang/customerBill/removePhysical/${row._id}`, { params: { reason } })
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.$message.success('彻底删除成功')
      this.getFinancialTrashList()
    }
  }
}
</script>

<style lang="less" scoped>
.flexContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cardHeader {
  font-size: 16px;
  font-weight: bold;
}
.search-bar {
  margin-bottom: 15px;
}
.el-pagination {
  margin-top: 15px;
}
</style>
